import './Footer.css.proxy.js';
/* src/components/Footer.svelte generated by Svelte v3.31.0 */
import {
	SvelteComponent,
	append,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	text,
	transition_in,
	transition_out
} from "../web_modules/svelte/internal.js";

import Switch from "./Switch.js";

function create_fragment(ctx) {
	let footer;
	let div0;
	let ul0;
	let li0;
	let t0;
	let t1;
	let li1;
	let a0;
	let t2;
	let t3;
	let li2;
	let a1;
	let t4;
	let t5;
	let li3;
	let a2;
	let t6;
	let t7;
	let li4;
	let a3;
	let t8;
	let t9;
	let li5;
	let a4;
	let t10;
	let t11;
	let li6;
	let a5;
	let t12;
	let t13;
	let div1;
	let ul1;
	let li7;
	let switch_1;
	let t14;
	let li8;
	let t15;
	let current;
	switch_1 = new Switch({});
	switch_1.$on("toggled", toggleLight);

	return {
		c() {
			footer = element("footer");
			div0 = element("div");
			ul0 = element("ul");
			li0 = element("li");
			t0 = text("links:");
			t1 = space();
			li1 = element("li");
			a0 = element("a");
			t2 = text("github");
			t3 = space();
			li2 = element("li");
			a1 = element("a");
			t4 = text("gitlab");
			t5 = space();
			li3 = element("li");
			a2 = element("a");
			t6 = text("linkedin");
			t7 = space();
			li4 = element("li");
			a3 = element("a");
			t8 = text("twitter");
			t9 = space();
			li5 = element("li");
			a4 = element("a");
			t10 = text("rym");
			t11 = space();
			li6 = element("li");
			a5 = element("a");
			t12 = text("last.fm");
			t13 = space();
			div1 = element("div");
			ul1 = element("ul");
			li7 = element("li");
			create_component(switch_1.$$.fragment);
			t14 = space();
			li8 = element("li");
			t15 = text("2020 chris p :)");
			this.h();
		},
		l(nodes) {
			footer = claim_element(nodes, "FOOTER", { class: true });
			var footer_nodes = children(footer);
			div0 = claim_element(footer_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			ul0 = claim_element(div0_nodes, "UL", { class: true });
			var ul0_nodes = children(ul0);
			li0 = claim_element(ul0_nodes, "LI", { class: true });
			var li0_nodes = children(li0);
			t0 = claim_text(li0_nodes, "links:");
			li0_nodes.forEach(detach);
			t1 = claim_space(ul0_nodes);
			li1 = claim_element(ul0_nodes, "LI", { class: true });
			var li1_nodes = children(li1);
			a0 = claim_element(li1_nodes, "A", { href: true, class: true });
			var a0_nodes = children(a0);
			t2 = claim_text(a0_nodes, "github");
			a0_nodes.forEach(detach);
			li1_nodes.forEach(detach);
			t3 = claim_space(ul0_nodes);
			li2 = claim_element(ul0_nodes, "LI", { class: true });
			var li2_nodes = children(li2);
			a1 = claim_element(li2_nodes, "A", { href: true, class: true });
			var a1_nodes = children(a1);
			t4 = claim_text(a1_nodes, "gitlab");
			a1_nodes.forEach(detach);
			li2_nodes.forEach(detach);
			t5 = claim_space(ul0_nodes);
			li3 = claim_element(ul0_nodes, "LI", { class: true });
			var li3_nodes = children(li3);
			a2 = claim_element(li3_nodes, "A", { href: true, class: true });
			var a2_nodes = children(a2);
			t6 = claim_text(a2_nodes, "linkedin");
			a2_nodes.forEach(detach);
			li3_nodes.forEach(detach);
			t7 = claim_space(ul0_nodes);
			li4 = claim_element(ul0_nodes, "LI", { class: true });
			var li4_nodes = children(li4);
			a3 = claim_element(li4_nodes, "A", { href: true, class: true });
			var a3_nodes = children(a3);
			t8 = claim_text(a3_nodes, "twitter");
			a3_nodes.forEach(detach);
			li4_nodes.forEach(detach);
			t9 = claim_space(ul0_nodes);
			li5 = claim_element(ul0_nodes, "LI", { class: true });
			var li5_nodes = children(li5);
			a4 = claim_element(li5_nodes, "A", { href: true, class: true });
			var a4_nodes = children(a4);
			t10 = claim_text(a4_nodes, "rym");
			a4_nodes.forEach(detach);
			li5_nodes.forEach(detach);
			t11 = claim_space(ul0_nodes);
			li6 = claim_element(ul0_nodes, "LI", { class: true });
			var li6_nodes = children(li6);
			a5 = claim_element(li6_nodes, "A", { href: true, class: true });
			var a5_nodes = children(a5);
			t12 = claim_text(a5_nodes, "last.fm");
			a5_nodes.forEach(detach);
			li6_nodes.forEach(detach);
			ul0_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t13 = claim_space(footer_nodes);
			div1 = claim_element(footer_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			ul1 = claim_element(div1_nodes, "UL", { class: true });
			var ul1_nodes = children(ul1);
			li7 = claim_element(ul1_nodes, "LI", { class: true });
			var li7_nodes = children(li7);
			claim_component(switch_1.$$.fragment, li7_nodes);
			li7_nodes.forEach(detach);
			t14 = claim_space(ul1_nodes);
			li8 = claim_element(ul1_nodes, "LI", { class: true });
			var li8_nodes = children(li8);
			t15 = claim_text(li8_nodes, "2020 chris p :)");
			li8_nodes.forEach(detach);
			ul1_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			footer_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(li0, "class", "svelte-v7i8zf");
			attr(a0, "href", "https://github.com/clpi");
			attr(a0, "class", "svelte-v7i8zf");
			attr(li1, "class", "svelte-v7i8zf");
			attr(a1, "href", "https://gitlab.com/clpi");
			attr(a1, "class", "svelte-v7i8zf");
			attr(li2, "class", "svelte-v7i8zf");
			attr(a2, "href", "https://linkedin.com");
			attr(a2, "class", "svelte-v7i8zf");
			attr(li3, "class", "svelte-v7i8zf");
			attr(a3, "href", "#");
			attr(a3, "class", "svelte-v7i8zf");
			attr(li4, "class", "svelte-v7i8zf");
			attr(a4, "href", "http://rateyourmusic.com/user/ooohm");
			attr(a4, "class", "fun svelte-v7i8zf");
			attr(li5, "class", "svelte-v7i8zf");
			attr(a5, "href", "http://last.fm/user/ooohm");
			attr(a5, "class", "fun svelte-v7i8zf");
			attr(li6, "class", "svelte-v7i8zf");
			attr(ul0, "class", "svelte-v7i8zf");
			attr(div0, "class", "left svelte-v7i8zf");
			attr(li7, "class", "svelte-v7i8zf");
			attr(li8, "class", "svelte-v7i8zf");
			attr(ul1, "class", "svelte-v7i8zf");
			attr(div1, "class", "right svelte-v7i8zf");
			attr(footer, "class", "svelte-v7i8zf");
		},
		m(target, anchor) {
			insert(target, footer, anchor);
			append(footer, div0);
			append(div0, ul0);
			append(ul0, li0);
			append(li0, t0);
			append(ul0, t1);
			append(ul0, li1);
			append(li1, a0);
			append(a0, t2);
			append(ul0, t3);
			append(ul0, li2);
			append(li2, a1);
			append(a1, t4);
			append(ul0, t5);
			append(ul0, li3);
			append(li3, a2);
			append(a2, t6);
			append(ul0, t7);
			append(ul0, li4);
			append(li4, a3);
			append(a3, t8);
			append(ul0, t9);
			append(ul0, li5);
			append(li5, a4);
			append(a4, t10);
			append(ul0, t11);
			append(ul0, li6);
			append(li6, a5);
			append(a5, t12);
			append(footer, t13);
			append(footer, div1);
			append(div1, ul1);
			append(ul1, li7);
			mount_component(switch_1, li7, null);
			append(ul1, t14);
			append(ul1, li8);
			append(li8, t15);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(switch_1.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(switch_1.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(footer);
			destroy_component(switch_1);
		}
	};
}

function toggleLight() {
	let body = document.body;
	let content = document.getElementsByClassName("content");
	body.classList.toggle("lightb");
	content.classList.toggle("light");
}

function instance($$self, $$props, $$invalidate) {
	return [toggleLight];
}

class Footer extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { toggleLight: 0 });
	}

	get toggleLight() {
		return toggleLight;
	}
}

export default Footer;
//# sourceMappingURL=Footer.js.map
